<template>
  <section>
    <div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <span style="font-size: 18px; font-weight: bold; display: inline-block; color: #6170d7">
            {{ list_details.hospitalName }}
          </span>
        </div>
      </div>
      <div class="table_top_div" style="margin-bottom: 5px">
        <!-- <div
          type="primary"
          @click="addProdcut()"
          style="
            color: #6170d7;
            width: 100%;
            font-size: 16px;
            padding: 5px 0 !important;
            margin-bottom: 25px;
            background-color: white;
            text-align: center;
            box-sizing: border-box;
            border: #6170d7 2px dashed;
            border-radius: 8px;
          "
        >
          <span style="font-size: 20px">+</span>
          添加上报产品
        </div> -->
        <el-table
          :data="list_details.details"
          :border="true"
          cell-class-name="cell_class_name"
          max-height="100%"
          :cell-style="cellStyle"
          header-cell-class-name="header_cell_name"
          highlight-current-row
          v-loading="listLoading"
          style="width: 100%"
        >
          <el-table-column prop="productSKU" label="产品编码" width="80">
            <template slot-scope="scope">
              {{ scope.row.groupM == 'TTL' ? scope.row.groupM : scope.row.productSKU }}
            </template>
          </el-table-column>
          <el-table-column label="指标片数">
            <el-table-column prop="monthlyTargetQuantity" :label="now_Month + '月'" width="50"></el-table-column>
            <el-table-column prop="nextMonthTarget" :label="next_Month + '月'" width="50"></el-table-column>
          </el-table-column>
          <el-table-column label="预估片数">
            <el-table-column prop="estimatedQuantity1" :label="now_Month + '月'" width="">
              <template slot-scope="scope">
                <span v-if="today_if == 0">{{ scope.row.estimatedQuantity1 }}</span>
                <el-input
                  v-else
                  type="number"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="scope.row.estimatedQuantity1"
                  class="border_none"
                  :disabled="!(today_if == 2) || scope.row.groupM == 'TTL'"
                  placeholder="请填写"
                  @blur="blurInputs1(scope.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="estimatedQuantity2" :label="next_Month + '月'" width="">
              <template slot-scope="scope">
                <span v-if="today_if == 0">{{ scope.row.estimatedQuantity2 }}</span>
                <el-input
                  v-else
                  type="number"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="scope.row.estimatedQuantity2"
                  class="border_none"
                  :disabled="!(today_if == 2) || scope.row.groupM == 'TTL'"
                  placeholder="请填写"
                  @blur="blurInputs1(scope.row)"
                ></el-input>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <div style="font-size: 12px">注：本页的预估手术量是基于销售的跟台观察和既往的医院耗用所做出的估测</div>
        <el-button
          v-if="today_if != 0"
          type="primary"
          v-preventReClick="3000"
          @click="save"
          style="color: white; width: 100%; font-size: 16; margin-top: 20px"
        >
          确认上报
        </el-button>
      </div>
    </div>
    <el-dialog title="请选择产品" :visible.sync="dialogVisible" width="30%">
      <el-select value-key="id" v-model="select_product" style="width: 100%" placeholder="请选择">
        <el-option
          v-if="!item.select_if && item.productSKU != '' && item.productSKU != null && item.productSKU != 'Total:'"
          @click.native="get_product_objec(item)"
          v-for="item in product_list"
          :label="item.productSKU"
          :value="item.productSKU"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="select_set_table(select_product)">添 加</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import { estimate_submitestimate } from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import { quillEditor } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
import Toolbar from '@/components/Toolbar'
import Approve from '@/components/Approve'

export default {
  components: { Toolbar, quillEditor, Approve },
  data() {
    return {
      list_details_table: [],
      now_Month: '',
      next_Month: '',
      today_if: 2,
      listLoading: false,
      select_product: '',
      dialogVisible: false,
      list_details: {},
      select_row: {},
      table_list: [],
      product_list: [],
    }
  },
  methods: {
    cellStyle({ row, column, rowIndex, columnIndex }) {
      //   console.log(rowIndex)
      console.log(columnIndex)
      if (columnIndex === 1 || columnIndex == 2) {
        return { backgroundColor: '#f6f9ff' }
      }
    },
    blurInputs1(row, items) {
      //   console.log(row)
      //   row.monthlyTargetAmount = Number(row.monthlyTargetQuantity * row.postExecutionAssessmentPrice)
      //   row.estimatedAmount1 = Number(row.estimatedQuantity1 * row.postExecutionAssessmentPrice)
      //   row.estimatedAmount2 = Number(row.estimatedQuantity2 * row.postExecutionAssessmentPrice)
      //   row.totalEstimatedCompletion1 = Number((row.estimatedAmount1 / row.monthlyTargetAmount) * 100)
      //   row.totalEstimatedGrowth1 = Number((row.estimatedAmount1 / row.lastYearAmount - 1) * 100)
      this.totalAll(this.list_details.details)
    },
    totalAll(row) {
      var estimatedQuantity2 = 0,
        estimatedQuantity1 = 0
      // monthlyTargetQuantity = 0,
      // totalEstimatedCompletion1 = 0,
      // totalEstimatedCompletion2 = 0,
      // estimatedAmount2 = 0,
      // estimatedAmount1 = 0,
      // monthlyTargetAmount = 0
      console.log(row)
      for (var i in row) {
        if (row[i].groupM != 'TTL') {
          estimatedQuantity1 += row[i].estimatedQuantity1 ? Number(row[i].estimatedQuantity1) : 0
          estimatedQuantity2 += row[i].estimatedQuantity2 ? Number(row[i].estimatedQuantity2) : 0
          //   monthlyTargetQuantity += row[i].monthlyTargetQuantity ? Number(row[i].monthlyTargetQuantity) : 0
          //   totalEstimatedCompletion1 += row[i].totalEstimatedCompletion1 ? Number(row[i].totalEstimatedCompletion1) : 0
          //   totalEstimatedCompletion2 += row[i].totalEstimatedCompletion2 ? Number(row[i].totalEstimatedCompletion2) : 0
          //   estimatedAmount2 += row[i].estimatedAmount2 ? Number(row[i].estimatedAmount2) : 0
          //   estimatedAmount1 += row[i].estimatedAmount1 ? Number(row[i].estimatedAmount1) : 0
          //   monthlyTargetAmount += row[i].monthlyTargetAmount ? Number(row[i].monthlyTargetAmount) : 0
          //   console.log(estimatedQuantity1)
        } else {
          row[i].estimatedQuantity1 = estimatedQuantity1
          row[i].estimatedQuantity2 = estimatedQuantity2
          //   row[i].monthlyTargetQuantity = monthlyTargetQuantity
          //   row[i].monthlyTargetQuantity = monthlyTargetQuantity
          //   row[i].estimatedAmount2 = estimatedAmount2
          //   row[i].estimatedAmount1 = estimatedAmount1
          //   row[i].monthlyTargetAmount = monthlyTargetAmount
          //   row[i].totalEstimatedCompletion1 = Number((row[i].estimatedAmount1 / row[i].totalMonthlyTargetAmount) * 100)
          //   row[i].totalEstimatedGrowth1 = Number((row[i].estimatedAmount1 / row[i].totalLastYearAmount - 1) * 100)
        }
      }
    },
    addProdcut() {
      if (this.today_if == 0) {
        this.$alert('请于每月20日至23日期间填写本月预估片数和下月月初预估片数，以确保及时更新数据。', '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      this.dialogVisible = true
    },
    back_url() {
      //   this.$router.replace({ path: this.$route.query.back_url })
      this.$router.go(-1)
    },
    async save(res) {
      //   var list = await this.hb_list()
      if (this.today_if == 0) {
        this.$alert('请于每月20日至23日期间填写本月预估片数和下月月初预估片数，以确保及时更新数据。', '提示', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true,
        })
        return
      }
      const { data } = await estimate_submitestimate(this.list_details)
      if (data.code == 200) {
        this.$message.success(data.msg)
        this.back_url()
      } else {
        this.$message.error(data.msg)
      }
    },
    hb_list() {
      this.table_list.forEach((item) => {
        let index = this.list_details.details.findIndex((e) => e.productId == item.productId)
        this.list_details.details[index] = item
      })
      return this.list_details
    },
    get_product_objec(row) {
      this.select_row = row
    },
    select_set_table() {
      this.select_row.select_if = true
      this.table_list.push(this.select_row)
      this.select_product = ''
      this.dialogVisible = false
    },
    list_details_fn() {
      var list = this.list_details.details
      list.filter((item) => {
        if (item.estimatedQuantity1 || item.estimatedQuantity2) {
          this.table_list.push(item)
        } else {
          this.product_list.push(item)
        }
      })
    },
  },
  mounted() {
    const now = new Date()
    if (this.$route.query.type == 'CK') {
      const currentMonth = now.getMonth() + 1
      const nextMonth = now.getMonth()
      this.next_Month = currentMonth
      if (nextMonth == 0) {
        this.now_Month = 12
      } else {
        this.now_Month = nextMonth
      }
      this.today_if = 0
    } else {
      const currentMonth = now.getMonth() + 1
      const nextMonth = now.getMonth() + 1 + 1
      this.now_Month = currentMonth
      if (nextMonth > 12) {
        this.next_Month = 1
      } else {
        this.next_Month = nextMonth
      }
      const date = new Date()
      const today = date.getDate()
      if (today > 19 && today < 24) {
        this.today_if = 2
      }
    }

    var hco_list = JSON.parse(localStorage.getItem('hco_list'))
    this.list_details = hco_list
    console.log(this.list_details)
    this.list_details_table = hco_list.details
    this.list_details_fn()
  },
}
</script>

<style>
.el-collapse-item__header {
  font-size: 14px !important;
  font-weight: bold !important;
  padding-left: 5px !important;
}
.cell_class_name {
  text-align: center !important;
}
.hidden_row {
  display: none !important;
}
</style>
